import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { c as clsx } from "../../../../chunks/clsx-DgYk2OaC.js";
import { Icon } from "../../../../foundations/icons/Icon.js";
const textInput = "_textInput_4oaur_1";
const iconWrapper = "_iconWrapper_4oaur_38";
const styles = {
  textInput,
  "textInput-success": "_textInput-success_4oaur_23",
  "textInput-error": "_textInput-error_4oaur_24",
  iconWrapper,
  "icon-error": "_icon-error_4oaur_49",
  "icon-success": "_icon-success_4oaur_53"
};
const TextInput = forwardRef(
  ({ required, isError, isSuccess, className, addon, ...props }, ref) => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          ...props,
          ref,
          required,
          className: clsx(
            styles.textInput,
            styles.textInput,
            isError && styles["textInput-error"],
            isSuccess && styles["textInput-success"],
            className
          )
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: styles.iconWrapper, children: [
        addon,
        isError && /* @__PURE__ */ jsx(Icon, { width: 24, height: 24, className: clsx(styles["icon-error"]), variant: "Error" }),
        isSuccess && /* @__PURE__ */ jsx(
          Icon,
          {
            width: 24,
            height: 24,
            className: clsx(styles["icon-success"]),
            variant: "Check1"
          }
        )
      ] })
    ] });
  }
);
export {
  TextInput
};
